import React from 'react';
import { convertToRaw, EditorState } from 'draft-js';
import _ from 'lodash-es';
import axios from 'axios';

import IconButton from '@material-ui/core/IconButton';
import IconClose from '@material-ui/icons/Close';
import { stateFromHTML } from 'draft-js-import-html';
import draftToHtml from 'draftjs-to-html';
import GetAppIcon from '@material-ui/icons/GetApp';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '../../Table/Table';
import { confirmAlert } from 'react-confirm-alert';
import DesignCard from '../../StoryTypeCard/DesignCard';
import ApiCard from '../../StoryTypeCard/ApiCard';
import BackEndCard from '../../StoryTypeCard/BackEndCard';
import FrontEndCard from '../../StoryTypeCard/FrontEndCard';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import {
  clearSuccessCriteria,
  getOneUserStories,
  getUserStories,
  saveUserStories,
  updateUserStories,
} from '../../../actions/userStories';

import withStyles from '@material-ui/core/styles/withStyles';
import IconZoomOutMap from '@material-ui/icons/ZoomOutMap';
import DeleteIcon from '@material-ui/icons/Delete';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconAdd from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import LinearProgress from '@material-ui/core/LinearProgress';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { API_END_POINTS } from 'utils/constants';

const { BASE_URL } = API_END_POINTS;

const MEGABYTES_10 = '10000000';
const IMAGE_TYPE_PNG = 'image/png';
const IMAGE_TYPE_JPEG = 'image/jpeg';
const FILE_TYPE_TXT = 'text/plain';
const FILE_TYPE_PDF = 'application/pdf';

const ERROR_EXCEEDED_SIZE = 'file_size_exceeded';
const ERROR_INVALID_FILE_TYPE = 'invalid_file_type';
const ERROR_UPLOAD_FAILED = 'upload_failed';
const SUCCESS_FILE_ATTACHED_NOT_UPLOADED = 'file_attached';
const SUCCESS_FILE_UPLOADED = 'file_uploaded_now';
const SUCCESS_FILE_UPLOADED_BEFORE = 'file_uploaded_before';

const styles = {
  gridItemPadding: {
    paddingTop: '0.25rem !important',
    paddingBottom: '0.25rem !important',
  },
  containerRoot: {
    marginTop: '4rem',
    backgroundColor: '#fff',
    paddingBottom: '2rem',
  },
  lowerButtonContainerRoot: {
    marginTop: '6rem',
  },
  cardRoot_attachment: {
    height: '12rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardMediaRoot_attachment: {
    height: '7rem',
    width: '100%',
  },
  cardMediaRoot_attachment_none: {
    height: '7rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '500',
    color: '#bdbdbd',
  },
  buttonRoot_attachment: {
    width: '100%',
    height: '100%',
  },
  inputLabelsRoot: {
    marginBottom: '1rem',
  },
  cardHeaderRoot_attachment: {
    padding: '4px',
  },
  cardActionsRoot_attachment: {
    padding: '4px',
    justifyContent: 'space-between',
  },
  cardBorderDanger: {
    border: '1px solid #f44336',
  },
  cardBorderInProgress: {
    border: '1px solid #eeeeee',
  },
  cardBorderDashed: {
    borderStyle: 'dashed',
  },
};

const FileAttachmentButton = ({ onFilesAttach, classes }) => (
  <Card
    variant='outlined'
    classes={{
      root: `${classes.cardBorderDashed}`,
    }}
  >
    <Grid
      container
      direction='column'
      justify='center'
      alignItems='center'
      classes={{ root: classes.cardRoot_attachment }}
    >
      <Button
        aria-label='upload files'
        component='label'
        size='large'
        classes={{ root: classes.buttonRoot_attachment }}
      >
        <input
          type='file'
          multiple
          hidden
          onChange={onFilesAttach}
          accept={`${IMAGE_TYPE_PNG}, ${IMAGE_TYPE_JPEG}, ${FILE_TYPE_PDF}, ${FILE_TYPE_TXT}`}
        />
        <IconAdd fontSize='large' />
      </Button>
    </Grid>
  </Card>
);

const FileAttachmentPlane = ({
                               file,
                               fileID,
                               status,
                               url,
                               classes,
                               onDeleteAttachment,
                             }) => {
  let borderType = '';
  let uploadingIndicator = null;
  let uploadIndicatorMessage = '';
  let actionButtons = null;
  let previewFile = (
    <CardMedia
      component='div'
      title={file.name}
      classes={{ root: classes.cardMediaRoot_attachment_none }}
    >
      X
    </CardMedia>
  );

  if (status === ERROR_EXCEEDED_SIZE) {
    uploadIndicatorMessage = 'File should be less than 10MB';
    borderType = classes.cardBorderDanger;
    actionButtons = (
      <IconButton
        aria-label='delete attachment'
        onClick={() => onDeleteAttachment(fileID)}
      >
        <DeleteIcon fontSize='small' />
      </IconButton>
    );
  } else if (status === ERROR_INVALID_FILE_TYPE) {
    uploadIndicatorMessage = 'File can be image, pdf or txt';
    borderType = classes.cardBorderDanger;
    actionButtons = (
      <IconButton
        aria-label='delete attachment'
        onClick={() => onDeleteAttachment(fileID)}
      >
        <DeleteIcon fontSize='small' />
      </IconButton>
    );
  } else if (status === ERROR_UPLOAD_FAILED) {
    uploadIndicatorMessage = 'Failed to upload';
    borderType = classes.cardBorderDanger;
    actionButtons = (
      <IconButton
        aria-label='delete attachment'
        onClick={() => onDeleteAttachment(fileID)}
      >
        <DeleteIcon fontSize='small' />
      </IconButton>
    );
  } else if (status === SUCCESS_FILE_ATTACHED_NOT_UPLOADED) {
    uploadIndicatorMessage = 'Uploading, please wait';
    uploadingIndicator = <LinearProgress />;
    borderType = classes.cardBorderInProgress;
    previewFile = (
      <CardMedia
        image={''}
        title={file.name}
        classes={{ root: classes.cardMediaRoot_attachment }}
      />
    );
  } else if (status === SUCCESS_FILE_UPLOADED) {
    uploadIndicatorMessage = 'File uploaded successfully';
    actionButtons = (
      <>
        <a href={url} target='_blank'>
          <IconButton aria-label='view attachment'>
            <GetAppIcon fontSize='small' />
          </IconButton>
        </a>
        <IconButton
          aria-label='delete attachment'
          onClick={() => onDeleteAttachment(fileID)}
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      </>
    );
    if (file.type === IMAGE_TYPE_JPEG || file.type === IMAGE_TYPE_PNG) {
      previewFile = (
        <CardMedia
          image={url}
          title={file.name}
          classes={{ root: classes.cardMediaRoot_attachment }}
        />
      );
    } else {
      previewFile = (
        <CardMedia
          component='div'
          title={file.name}
          classes={{ root: classes.cardMediaRoot_attachment_none }}
        >
          Preview not available
        </CardMedia>
      );
    }
  } else if (status === SUCCESS_FILE_UPLOADED_BEFORE) {
    actionButtons = (
      <>
        <a href={url} target='_blank'>
          <IconButton aria-label='view attachment'>
            <GetAppIcon fontSize='small' />
          </IconButton>
        </a>
        <IconButton
          aria-label='delete attachment'
          onClick={() => onDeleteAttachment(fileID)}
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      </>
    );
    if (file.type === IMAGE_TYPE_JPEG || file.type === IMAGE_TYPE_PNG) {
      previewFile = (
        <CardMedia
          image={url}
          title={file.name}
          classes={{ root: classes.cardMediaRoot_attachment }}
        />
      );
    } else {
      previewFile = (
        <CardMedia
          component='div'
          title={file.name}
          classes={{ root: classes.cardMediaRoot_attachment_none }}
        >
          Preview not available
        </CardMedia>
      );
    }
  }
  return (
    <Card
      variant='outlined'
      classes={{
        root: `${classes.cardRoot_attachment} ${borderType}`,
      }}
    >
      {uploadingIndicator}
      <CardHeader
        classes={{ root: classes.cardHeaderRoot_attachment }}
        subheader={
          <Typography title={file.name} variant='caption' noWrap>
            {file.name}
          </Typography>
        }
      />
      {previewFile}
      <CardActions
        disableSpacing
        classes={{ root: classes.cardActionsRoot_attachment }}
      >
        <div>
          <Typography title={uploadIndicatorMessage} variant='caption'>
            {uploadIndicatorMessage}
          </Typography>
        </div>
        <div>{actionButtons}</div>
      </CardActions>
    </Card>
  );
};
class NewUserStory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previousPage:
        props.location.state && props.location.state.from
          ? props.location.state.from
          : null,
      redirectTo: null,
      currentStory: {},
      criteriaData: [],
      criteriaLength: 0,
      title: '',
      index: '',
      userStoriesTitleOne: '',
      userStoriesTitleTwo: '',
      userStoriesTitleThree: '',
      userStoriesDescription: {},
      titleError: false,
      userStoriesTitleOneError: false,
      userStoriesTitleTwoError: false,
      userStoriesTitleThreeError: false,
      userStoriesDescriptionError: false,
      description: '',
      complexity: 'Low',
      storyType: 'Design Card',
      apiTool: 'Java',
      apiAuthenticatedFieldError: false,
      apiAccessibleFieldError: false,
      apiDescriptionFieldError: false,
      apiArchitectureFieldError: false,
      apiDatastoreFieldError: false,
      apiTestDescFieldError: false,
      apiRefDescFieldError: false,
      apiAuthenticatedField: '',
      apiAccessibleField: '',
      apiDescription: '',
      apiArchitecture: '',
      apiDatastore: '',
      apiTestCasesError: false,
      apiTestDesc: '',
      apiRefDesc: '',
      backEndTool: 'Go',
      backEndDesignMock: '',
      backEndAuthenticatedField: '',
      backEndAccessibleField: '',
      backEndViewNameField: '',
      backEndViewNavigationField: '',
      backEndEditorDescState: EditorState.createEmpty(),
      onBackEndEditorDescStateChange: '',
      backEndEditorWorkFlowState: EditorState.createEmpty(),
      onBackEndEditorWorkFlowStateChange: '',
      backEndDesc: '',
      backEndWorkFlow: '',
      designTool: 'Adobe',
      designMock: '',
      designViewNameField: '',
      designViewNavigationField: '',
      designEditorDescState: EditorState.createEmpty(),
      onDesignEditorDescStateChange: '',
      designEditorElementState: EditorState.createEmpty(),
      onDesignEditorElementStateChange: '',
      designEditorActionElementState: EditorState.createEmpty(),
      onDesignEditorActionElementStateChange: '',
      designControlField: '',
      designDesc: '',
      designElement: '',
      designActionElement: '',
      frontEndTool: 'HTML/CSS',
      frontEndMockRef: '',
      frontEndDesignMockRef: '',
      frontEndViewNameField: '',
      frontEndViewNavigationField: '',
      onFrontEndEditorDescStateChange: '',
      frontEndEditorDescState: EditorState.createEmpty(),
      frontEndEditorWorkFlowState: EditorState.createEmpty(),
      onFrontEndEditorWorkFlowStateChange: '',
      frontEndSwaggerField: '',
      frontEndDesc: '',
      frontEndWorkFlow: '',
      storyAcceptanceText: '',
      addStory: '',
      storyId: '',
      editStory: '',
      projectId: '',
      sprintId: '',
      isLoading: false,
      editorState: EditorState.createEmpty(),
      apiEditorDescState: EditorState.createEmpty(),
      apiEditorTestDescState: EditorState.createEmpty(),
      apiTestRefEditorDescState: EditorState.createEmpty(),
      disabled: false,
      redirect: false,
      uploadedFilesList: [],
    };
    this.designViewNameRef = React.createRef();
    this.designViewNavigationRef = React.createRef();
    this.frontendDesignMockRef = React.createRef();
    this.frontendViewMockRef = React.createRef();
    this.frontendViewNavigationRef = React.createRef();
    this.backEndAuthenticatedRef = React.createRef();
    this.backEndAccessibleRef = React.createRef();
    this.backEndViewNameRef = React.createRef();
    this.backEndViewNavigationRef = React.createRef();
    this.apiAccessibleRef = React.createRef();
    this.apiDescriptionRef = React.createRef();
    this.apiArchitectureRef = React.createRef();
    this.apiDatastoreRef = React.createRef();
  }

  componentDidMount() {
    const { history } = this.props;
    if (history) {
      let projectId = this.props.sprint.project;
      let sprintId = this.props.sprint._id;
      let storyId = this.props.match.params.storyid;
      let state;
      if (this.props.duplicate) {
        state = 'duplicateStory';
      } else {
        state = storyId ? 'editStory' : 'addStory';
      }
      let index = null;
      let stateToUpdate = {};
      stateToUpdate = {
        addStory: state,
        editStory: state,
        duplicateStory: state,
        storyId: storyId,
        projectId: projectId,
        sprintId: sprintId,
        index: index,
      };

      /** Find story in the list of user stories
       * */
      let currentStory;
      if (
        !this.state.currentStory._id &&
        storyId &&
        this.state.addStory !== 'addStory'
      ) {
        currentStory = this.props.userStoriesData[storyId];
        if (currentStory) {
          const storyStates = this.storyToStates({ data: currentStory });
          stateToUpdate = {
            ...stateToUpdate,
            ...storyStates,
            index: index,
            currentStory: currentStory,
          };
        }
        if (!currentStory) {
          this.getOneUserStory();
        }
      }

      if (
        !this.state.currentStory._id &&
        this.state.addStory !== 'addStory' &&
        this.props.oneUserStoriesList
      ) {
        const storyStates = this.storyToStates(this.props.oneUserStoriesList);
        stateToUpdate = {
          ...stateToUpdate,
          ...storyStates,
          currentStory: this.props.oneUserStoriesList,
        };
      }
      this.setState(stateToUpdate);
    }
  }

  constructCriteriaTable = (criterias) => {
    return criterias.map((val, i) => {
      let acceptanceCriterias = [];
      acceptanceCriterias.push(i + 1);
      acceptanceCriterias.push(val.text);
      acceptanceCriterias.push(
        <div className='success-criteria-delete'>
          <IconButton
            color='secondary'
            onClick={() => this.handleDeleteStoryAcceptance(i)}
          >
            <IconClose />
          </IconButton>
        </div>
      );
      return acceptanceCriterias;
    });
  };

  async uploadFile(attachedFile) {
    const { file, fileID } = attachedFile;
    const indexOfFileInUploadList = this.state.uploadedFilesList.findIndex(
      (uploadFile) => uploadFile.fileID === fileID
    );
    const originalFileInUploadList = this.state.uploadedFilesList[
      indexOfFileInUploadList
      ];
    console.log('>>>', indexOfFileInUploadList);

    try {
      const authToken = localStorage.getItem('accessToken');
      const PRE_SIGNED_URL = `projects/${this.state.projectId}/sprints/${
        this.state.sprintId
      }/presigned-url`;

      let fileName = `${_.random(10000, 9999)}.${file.type}`;
      if (file.name && file.name.length !== 0) {
        fileName = file.name;
      }

      // Make a request to get the presigned url
      const response = await axios({
        method: 'post',
        url: `${BASE_URL}${PRE_SIGNED_URL}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        data: {
          fileName,
        },
      });

      if (response && response.status === 200) {
        const awsPresignedURLResponse =
          response && response.data && response.data.data
            ? response.data.data
            : {};

        if (_.isEmpty(awsPresignedURLResponse) === true) {
          throw new Error('Presigned url is empty');
        }

        const {
          url: awsPresignedURL,
          fields: awsPresignedFields,
        } = awsPresignedURLResponse;

        const awsUploadFormData = new FormData();
        awsUploadFormData.set('Policy', awsPresignedFields.Policy);
        awsUploadFormData.set(
          'X-Amz-Algorithm',
          awsPresignedFields['X-Amz-Algorithm']
        );
        awsUploadFormData.set(
          'X-Amz-Credential',
          awsPresignedFields['X-Amz-Credential']
        );
        awsUploadFormData.set('X-Amz-Date', awsPresignedFields['X-Amz-Date']);
        awsUploadFormData.set(
          'X-Amz-Signature',
          awsPresignedFields['X-Amz-Signature']
        );
        awsUploadFormData.set('key', awsPresignedFields.key);
        awsUploadFormData.append('file', file);

        // upload the file tp aws s3 bucket
        const uploadResponse = await axios({
          method: 'post',
          url: awsPresignedURL,
          data: awsUploadFormData,
        });

        // upload successfully
        this.setState({
          uploadedFilesList: [
            ...this.state.uploadedFilesList.slice(0, indexOfFileInUploadList),
            {
              ...this.state.uploadedFilesList[indexOfFileInUploadList],
              status: SUCCESS_FILE_UPLOADED,
              url: `${awsPresignedURL}/${awsPresignedFields.key}`,
            },
            ...this.state.uploadedFilesList.slice(indexOfFileInUploadList + 1),
          ],
        });
      } else {
        throw new Error('File upload request not 200');
      }
    } catch (err) {
      this.setState({
        uploadedFilesList: [
          ...this.state.uploadedFilesList.slice(0, indexOfFileInUploadList),
          {
            ...this.state.uploadedFilesList[indexOfFileInUploadList],
            status: ERROR_UPLOAD_FAILED,
          },
          ...this.state.uploadedFilesList.slice(indexOfFileInUploadList + 1),
        ],
      });
      console.error('err in uploading file : ', err);
    }
  }

  onDeleteAttachment = (fileIDToDelete) => {
    if (fileIDToDelete) {
      const postDeleteUploadedFilesList = this.state.uploadedFilesList.filter(
        (uploadedFiles) =>
          String(uploadedFiles.fileID) !== String(fileIDToDelete)
      );
      this.setState({
        uploadedFilesList: postDeleteUploadedFilesList,
      });
    }
  };

  onFilesAttach = (event) => {
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length !== 0
    ) {
      const {
        target: { files },
      } = event;

      let uploadedFilesList = this.state.uploadedFilesList;

      for (const file of files) {
        let attachedFile = {
          fileID: `${_.random(100000, 1000000)}`,
          file: file,
          status: '',
          url: '',
        };

        if (
          !(
            file.type === IMAGE_TYPE_PNG ||
            file.type === IMAGE_TYPE_JPEG ||
            file.type === FILE_TYPE_TXT ||
            file.type === FILE_TYPE_PDF
          )
        ) {
          attachedFile.status = ERROR_INVALID_FILE_TYPE;
        } else if (file.size > MEGABYTES_10) {
          attachedFile.status = ERROR_EXCEEDED_SIZE;
        } else {
          attachedFile.status = SUCCESS_FILE_ATTACHED_NOT_UPLOADED;
        }

        uploadedFilesList.push(attachedFile);
      }

      this.setState(
        {
          uploadedFilesList,
        },
        () => {
          // Only when initially boxes are rendered, we will upload compatible files
          this.state.uploadedFilesList.forEach((uploadedFile) => {
            if (
              uploadedFile.status === SUCCESS_FILE_ATTACHED_NOT_UPLOADED &&
              uploadedFile.url.length === 0 &&
              uploadedFile.file
            ) {
              this.uploadFile(uploadedFile);
            }
          });
        }
      );
    }
  };

  storyToStates = (story) => {
    let storyDescription = {};
    let state = {};
    if (story && story.data) {
      const storyType = story.data.storyType;
      try {
        storyDescription = JSON.parse(story.data.description);
      } catch (e) {
        storyDescription = story.data.description;
      }
      if (storyType === 'API Card') {
        state = this.getAPICardDetailsFromDescription(storyDescription);
      }
      if (storyType === 'Backend Card') {
        state = this.getBackendCardDetailsFromDescription(storyDescription);
      }
      if (storyType === 'Design Card') {
        state = this.getDesignCardDetailsFromDescription(storyDescription);
      }
      if (storyType === 'Frontend Card') {
        state = this.getFrontendCardDetailsFromDescription(storyDescription);
      }

      const uploadedFilesList = story.data.attachments.map((attachment) => {
        const reverseFileName = attachment.filename
          .split('')
          .reverse()
          .join('');

        const fileType = reverseFileName
          .split('.')[0]
          .split('')
          .reverse()
          .join('');

        let type = '';
        if (fileType === 'jpg' || fileType === 'jpeg') {
          type = IMAGE_TYPE_JPEG;
        } else if (fileType === 'png') {
          type = IMAGE_TYPE_PNG;
        } else if (fileType === 'pdf') {
          type = FILE_TYPE_PDF;
        } else if (fileType === 'txt') {
          type = FILE_TYPE_PDF;
        }

        return {
          fileID: `${_.random(100000, 1000000)}`,
          file: { name: attachment.filename, type },
          status: SUCCESS_FILE_UPLOADED_BEFORE,
          url: attachment.bucketLink,
          id: attachment.id,
        };
      });
      console.log('>>>', uploadedFilesList);
      const storyCriterias = story.data.criteria;
      state = {
        ...state,
        title: story.data.title,
        userStoriesDescription: storyDescription.description,
        complexity: story.data.complexity,
        storyType: storyType,
        criteriaData: this.constructCriteriaTable(storyCriterias),
        uploadedFilesList,
      };
    }

    const contentState = stateFromHTML(storyDescription.description);
    const editorState = EditorState.createWithContent(contentState);
    const contentState2 = stateFromHTML(storyDescription.apiTestDesc);
    const contentState3 = stateFromHTML(storyDescription.apiRefDesc);
    const contentState4 = stateFromHTML(storyDescription.backEndDesc);
    const contentState5 = stateFromHTML(storyDescription.backEndWorkFlow);
    const contentState6 = stateFromHTML(storyDescription.designDesc);
    const contentState7 = stateFromHTML(storyDescription.designElement);
    const contentState8 = stateFromHTML(storyDescription.designActionElement);
    const contentState9 = stateFromHTML(storyDescription.frontEndDesc);
    const contentState10 = stateFromHTML(storyDescription.frontEndWorkFlow);

    const editorDescState = EditorState.createWithContent(contentState2);
    const editorRefState = EditorState.createWithContent(contentState3);
    const editorBackEndDescState = EditorState.createWithContent(contentState4);
    const editorWorkFlowState = EditorState.createWithContent(contentState5);
    const editorDesignDescState = EditorState.createWithContent(contentState6);
    const editorDesignElementState = EditorState.createWithContent(
      contentState7
    );
    const editorDesignActionElementState = EditorState.createWithContent(
      contentState8
    );
    const editorFrontEndDescState = EditorState.createWithContent(
      contentState9
    );
    const editorFrontEndWorkFlowState = EditorState.createWithContent(
      contentState10
    );
    return {
      ...state,
      editorState: editorState,
      apiEditorDescState: editorDescState,
      apiTestRefEditorDescState: editorRefState,
      backEndEditorDescState: editorBackEndDescState,
      backEndEditorWorkFlowState: editorWorkFlowState,
      designEditorDescState: editorDesignDescState,
      designEditorElementState: editorDesignElementState,
      designEditorActionElementState: editorDesignActionElementState,
      frontEndEditorDescState: editorFrontEndDescState,
      frontEndEditorWorkFlowState: editorFrontEndWorkFlowState,
    };
  };

  getAPICardDetailsFromDescription(storyDescription) {
    return {
      apiAuthenticatedField: storyDescription.apiAuthenticatedField,
      apiAccessibleField: storyDescription.apiAccessibleField,
      apiDescription: storyDescription.description,
      apiArchitecture: storyDescription.apiArchitecture,
      apiDatastore: storyDescription.apiDatastore,
      apiTestDesc: storyDescription.apiTestDesc,
      apiRefDesc: storyDescription.apiRefDesc,
      apiTool: storyDescription.apiTool,
    };
  }

  getBackendCardDetailsFromDescription(storyDescription) {
    return {
      backEndTool: storyDescription.backEndTool,
      backEndDesignMock: storyDescription.backEndDesignMock,
      backEndAuthenticatedField: storyDescription.backEndAuthenticatedField,
      backEndAccessibleField: storyDescription.backEndAccessibleField,
      backEndViewNameField: storyDescription.backEndViewNameField,
      backEndViewNavigationField: storyDescription.backEndViewNavigationField,
      backEndDesc: storyDescription.backEndDesc,
      backEndWorkFlow: storyDescription.backEndWorkFlow,
    };
  }

  getDesignCardDetailsFromDescription(storyDescription) {
    return {
      designTool: storyDescription.designTool,
      designMock: storyDescription.designMock,
      designViewNameField: storyDescription.designViewNameField,
      designViewNavigationField: storyDescription.designViewNavigationField,
      designControlField: storyDescription.designControlField,
      designDesc: storyDescription.designDesc,
      designElement: storyDescription.designElement,
      designActionElement: storyDescription.designActionElement,
    };
  }

  getFrontendCardDetailsFromDescription(storyDescription) {
    return {
      frontEndTool: storyDescription.frontEndTool,
      frontEndMockRef: storyDescription.frontEndMockRef,
      frontEndDesignMockRef: storyDescription.frontEndDesignMockRef,
      frontEndViewNameField: storyDescription.frontEndViewNameField,
      frontEndViewNavigationField: storyDescription.frontEndViewNavigationField,
      frontEndSwaggerField: storyDescription.frontEndSwaggerField,
      frontEndDesc: storyDescription.frontEndDesc,
      frontEndWorkFlow: storyDescription.frontEndWorkFlow,
    };
  }

  getOneUserStory = () => {
    const {
      projectId,
      sprintId,
      storyId,
      editStory,
      duplicateStory,
    } = this.state;
    if (editStory === 'editStory' || duplicateStory === 'duplicateStory') {
      this.props.getOneUserStories(projectId, sprintId, storyId);
    }
  };

  back = () => {
    this.props.clearSuccessCriteria();
    if (
      this.state.previousPage &&
      this.state.previousPage.toLowerCase() === 'review'
    ) {
      let redirectTo = `/projects/${this.state.projectId}/sprints/${
        this.state.sprintId
      }/info`;
      this.setState({
        redirectTo: redirectTo,
      });
      return;
    }

    if (
      this.state.previousPage &&
      this.state.previousPage.toLowerCase() === 'story-list'
    ) {
      let redirectTo = `/projects/${this.state.projectId}`;
      this.setState({
        redirectTo: redirectTo,
      });
      return;
    }

    {
      this.setState({
        redirect: true,
      });
    }
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
    this.setState(
      {
        userStoriesDescription: draftToHtml(
          convertToRaw(editorState.getCurrentContent())
        ),
      },
      () => {
        if (this.state.storyType === 'Design Card') {
          this.handleDesignValidation();
        }
        if (this.state.storyType === 'API Card') {
          this.handleApiValidation();
        }
        if (this.state.storyType === 'Frontend Card') {
          this.handleFrontEndValidation();
        }
        if (this.state.storyType === 'Backend Card') {
          this.handleBackEndValidation();
        }
      }
    );
  };

  onEditorStateBlur = (descText) => {
    if (!descText) {
      this.setState({ userStoriesDescriptionError: true });
    } else {
      this.setState({ userStoriesDescriptionError: false });
    }
  };

  onApiDescEditorStateChange = (apiEditorDescState) => {
    console.log('aa');
    this.setState({
      apiEditorDescState: apiEditorDescState,
    });
    this.setState({
      description: draftToHtml(
        convertToRaw(apiEditorDescState.getCurrentContent())
      ),
    });
  };

  onApiTestDescEditorStateChange = (apiEditorTestDescState) => {
    this.setState({
      apiEditorTestDescState: apiEditorTestDescState,
    });
    this.setState({
      apiTestDesc: draftToHtml(
        convertToRaw(apiEditorTestDescState.getCurrentContent())
      ),
    });
  };

  onApiRefEditorStateChange = (apiTestRefEditorDescState) => {
    this.setState({
      apiTestRefEditorDescState,
    });
    this.setState(
      {
        apiRefDesc: draftToHtml(
          convertToRaw(apiTestRefEditorDescState.getCurrentContent())
        ),
      },
      () => {
        if (this.state.storyType === 'API Card') {
          this.handleApiValidation();
        }
      }
    );
  };

  onBackEndEditorDescStateChange = (backEndEditorDescState) => {
    this.setState({
      backEndEditorDescState,
    });
    this.setState({
      description: draftToHtml(
        convertToRaw(backEndEditorDescState.getCurrentContent())
      ),
    });
  };

  onBackEndEditorWorkFlowStateChange = (backEndEditorWorkFlowState) => {
    this.setState({
      backEndEditorWorkFlowState,
    });
    this.setState(
      {
        backEndWorkFlow: draftToHtml(
          convertToRaw(backEndEditorWorkFlowState.getCurrentContent())
        ),
      },
      () => {
        if (this.state.storyType === 'Backend Card') {
          this.handleBackEndValidation();
        }
      }
    );
  };

  onDesignEditorDescStateChange = (designEditorDescState) => {
    this.setState({
      designEditorDescState,
    });
    this.setState({
      description: draftToHtml(
        convertToRaw(designEditorDescState.getCurrentContent())
      ),
    });
  };

  onDesignEditorElementStateChange = (designEditorElementState) => {
    this.setState({
      designEditorElementState,
    });
    this.setState(
      {
        designElement: draftToHtml(
          convertToRaw(designEditorElementState.getCurrentContent())
        ),
      },
      () => {
        if (this.state.storyType === 'Design Card') {
          this.handleDesignValidation();
        }
      }
    );
  };

  onDesignEditorActionElementStateChange = (designEditorActionElementState) => {
    this.setState({
      designEditorActionElementState,
    });
    this.setState(
      {
        designActionElement: draftToHtml(
          convertToRaw(designEditorActionElementState.getCurrentContent())
        ),
      },
      () => {
        if (this.state.storyType === 'Design Card') {
          this.handleDesignValidation();
        }
      }
    );
  };

  onFrontEndEditorDescStateChange = (frontEndEditorDescState) => {
    this.setState({
      frontEndEditorDescState,
    });
    this.setState({
      description: draftToHtml(
        convertToRaw(frontEndEditorDescState.getCurrentContent())
      ),
    });
  };

  onFrontEndEditorWorkFlowStateChange = (frontEndEditorWorkFlowState) => {
    this.setState({
      frontEndEditorWorkFlowState,
    });
    this.setState(
      {
        frontEndWorkFlow: draftToHtml(
          convertToRaw(frontEndEditorWorkFlowState.getCurrentContent())
        ),
      },
      () => {
        if (this.state.storyType === 'Frontend Card') {
          this.handleFrontEndValidation();
        }
      }
    );
  };

  handleKeyDown = ({ keyCode, target: { name } }) => {
    const availableInputs = {
      designMock: this.designViewNameRef,
      designViewNameField: this.designViewNavigationRef,
      frontEndMockRef: this.frontendDesignMockRef,
      frontEndDesignMockRef: this.frontendViewMockRef,
      frontEndViewNameField: this.frontendViewNavigationRef,
      backEndDesignMock: this.backEndAuthenticatedRef,
      backEndAuthenticatedField: this.backEndAccessibleRef,
      backEndAccessibleField: this.backEndViewNameRef,
      backEndViewNameField: this.backEndViewNavigationRef,
      apiAuthenticatedField: this.apiAccessibleRef,
      apiAccessibleField: this.apiDescriptionRef,
      apiDescription: this.apiArchitectureRef,
      apiArchitecture: this.apiDatastoreRef,
    };

    if (keyCode === 13 && availableInputs[name]) {
      availableInputs[name].current.focus();
    }
  };

  render() {
    if (this.state.redirectTo) {
      return <Redirect to={this.state.redirectTo} />;
    }
    if (this.state.redirect) {
      return (
        <Redirect
          to={`/projects/${this.state.projectId}/sprints/${
            this.state.sprintId
          }`}
        />
      );
    }
    const {
      editorState,
      apiEditorDescState,
      apiTestRefEditorDescState,
    } = this.state;

    const { classes } = this.props;

    const complexity = [
      {
        value: 'Low',
        label: 'Low',
      },
      {
        value: 'Medium',
        label: 'Medium',
      },
      {
        value: 'High',
        label: 'High',
      },
    ];
    const storyType = [
      {
        value: 'Design Card',
        label: 'Design Card',
      },
      {
        value: 'Frontend Card',
        label: 'Frontend Card',
      },
      {
        value: 'Backend Card',
        label: 'Backend Card',
      },
      {
        value: 'API Card',
        label: 'API Card',
      },
    ];

    const tableHeadData = ['#', 'Criteria', 'Action'];
    const { criteriaData, editStory, index } = this.state;
    let typeForm, wikiText, wikiUrl, clearEditor;

    switch (this.state.storyType) {
      case 'Design Card':
        typeForm = (
          <DesignCard
            handleChange={(e) => {
              this.handleChange(e);
            }}
            handleTypeChange={(e) => {
              this.handleTypeChange(e);
            }}
            designTool={this.state.designTool}
            designMock={this.state.designMock}
            designViewNameField={this.state.designViewNameField}
            designViewNavigationField={this.state.designViewNavigationField}
            designEditorDescState={this.state.designEditorDescState}
            onDesignEditorDescStateChange={this.onDesignEditorDescStateChange}
            designEditorElementState={this.state.designEditorElementState}
            onDesignEditorElementStateChange={
              this.onDesignEditorElementStateChange
            }
            designEditorActionElementState={
              this.state.designEditorActionElementState
            }
            onDesignEditorActionElementStateChange={
              this.onDesignEditorActionElementStateChange
            }
            designControlField={this.state.designControlField}
            ref={{
              designViewNameRef: this.designViewNameRef,
              designViewNavigationRef: this.designViewNavigationRef,
            }}
            handleKeyDown={this.handleKeyDown}
          />
        );
        wikiText = 'Learn more about design card';
        wikiUrl = '?#';
        break;
      case 'Backend Card':
        typeForm = (
          <BackEndCard
            handleChange={(e) => {
              this.handleChange(e);
            }}
            handleTypeChange={(e) => {
              // this.handleTypeChange(e);
              this.handleChange(e);
            }}
            backEndTool={this.state.backEndTool}
            backEndDesignMock={this.state.backEndDesignMock}
            backEndAuthenticatedField={this.state.backEndAuthenticatedField}
            backEndAccessibleField={this.state.backEndAccessibleField}
            backEndViewNameField={this.state.backEndViewNameField}
            backEndViewNavigationField={this.state.backEndViewNavigationField}
            backEndEditorDescState={this.state.backEndEditorDescState}
            onBackEndEditorDescStateChange={this.onBackEndEditorDescStateChange}
            backEndEditorWorkFlowState={this.state.backEndEditorWorkFlowState}
            onBackEndEditorWorkFlowStateChange={
              this.onBackEndEditorWorkFlowStateChange
            }
            ref={{
              backEndAuthenticatedRef: this.backEndAuthenticatedRef,
              backEndAccessibleRef: this.backEndAccessibleRef,
              backEndViewNameRef: this.backEndViewNameRef,
              backEndViewNavigationRef: this.backEndViewNavigationRef,
            }}
            handleKeyDown={this.handleKeyDown}
          />
        );
        wikiText = 'Learn more about backend card';
        wikiUrl = '?#';
        break;
      case 'Frontend Card':
        typeForm = (
          <FrontEndCard
            handleChange={(e) => {
              this.handleChange(e);
            }}
            frontEndTool={this.state.frontEndTool}
            frontEndMockRef={this.state.frontEndMockRef}
            frontEndDesignMockRef={this.state.frontEndDesignMockRef}
            frontEndViewNameField={this.state.frontEndViewNameField}
            frontEndViewNavigationField={this.state.frontEndViewNavigationField}
            onFrontEndEditorDescStateChange={
              this.onFrontEndEditorDescStateChange
            }
            frontEndEditorDescState={this.state.frontEndEditorDescState}
            frontEndEditorWorkFlowState={this.state.frontEndEditorWorkFlowState}
            onFrontEndEditorWorkFlowStateChange={
              this.onFrontEndEditorWorkFlowStateChange
            }
            frontEndSwaggerField={this.state.frontEndSwaggerField}
            ref={{
              frontendDesignMockRef: this.frontendDesignMockRef,
              frontendViewMockRef: this.frontendViewMockRef,
              frontendViewNavigationRef: this.frontendViewNavigationRef,
            }}
            handleKeyDown={this.handleKeyDown}
          />
        );
        wikiText = 'Learn more about frontend card';
        wikiUrl = '?#';
        break;
      case 'API Card':
        typeForm = (
          <ApiCard
            handleChange={(e) => {
              this.handleChange(e);
            }}
            handleTypeChange={(e) => {
              this.handleTypeChange(e);
            }}
            onApiDescEditorStateChange={this.onApiDescEditorStateChange}
            apiTool={this.state.apiTool}
            apiAuthenticatedField={this.state.apiAuthenticatedField}
            apiDescription={this.state.description}
            apiArchitecture={this.state.apiArchitecture}
            apiDatastore={this.state.apiDatastore}
            apiEditorDescState={this.state.apiEditorDescState}
            apiAccessibleField={this.state.apiAccessibleField}
            apiEditorTestDescState={this.state.apiEditorTestDescState}
            onApiTestDescEditorStateChange={this.onApiTestDescEditorStateChange}
            apiTestRefEditorDescState={this.state.apiTestRefEditorDescState}
            onApiRefEditorStateChange={this.onApiRefEditorStateChange}
            handleApiAuthenticatedValidation={
              this.handleApiAuthenticatedValidation
            }
            apiAuthenticatedFieldError={this.state.apiAuthenticatedFieldError}
            ref={{
              apiAccessibleRef: this.apiAccessibleRef,
              apiDescriptionRef: this.apiDescriptionRef,
              apiArchitectureRef: this.apiArchitectureRef,
              apiDatastoreRef: this.apiDatastoreRef,
            }}
            handleKeyDown={this.handleKeyDown}
          />
        );
        clearEditor = 'API Card';
        wikiText = 'Learn more about api card';
        wikiUrl = '?#';
        break;
      default:
      // code block
    }

    let pageTitle = 'Create user stories';
    let pageSubtitle = `Add User Story No. ${this.props.userStoriesSavedData
      .length + 1}`;
    let submitButtonText = 'Save story';
    if (editStory === 'editStory') {
      pageTitle = 'Update user stories';
      pageSubtitle = `Update User Story No. ${index}`;
      submitButtonText = 'Update story';
    }

    let criteriaDataIndex = 1;
    if (criteriaData.length > 0) {
      criteriaDataIndex = criteriaData.length + 1;
    }

    console.log('this.state.uploadedFilesList', this.state.uploadedFilesList);
    return (
      <>
        {this.state.isLoading && <LinearProgress />}
        <Grid container spacing={5}>
          <Grid item sm={12} md={12} lg={12}>
            <h3>{pageTitle}</h3>
            {/*<h5>{pageSubtitle}</h5>*/}
          </Grid>
          <Grid
            container
            spacing={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            justify='flex-end'
          >
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <TextField
                id='select-story-type'
                name='timezone'
                label='Story Type'
                select
                // InputProps={{
                //   readOnly: loadings['isUpdatingProfile'],
                // }}
                fullWidth
                margin='dense'
                // helperText={
                //   errors['timezone'] && errors['timezone'] !== ''
                //     ? errors['timezone']
                //     : ''
                // }
                // error={errors['timezone'] && errors['timezone'] !== ''}
                value={this.state.storyType}
                onChange={this.handleUserStoryType}
              >
                {storyType.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <Grid item sm={12} md={12} lg={12}>
            <TextField
              id='title'
              inputProps={{
                maxLength: 150,
              }}
              label='Title of the story'
              fullWidth={true}
              error={this.state.titleError}
              value={this.state.title}
              onChange={(e) => {
                this.handleChange(e);
              }}
              onBlur={(e) => {
                this.handleUserStoriesTitleValidation(e);
              }}
              name='title'
              onKeyDown={this.handleKeyDown}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <TextField
              id='select-story-type'
              name='complexity'
              label='Complexity'
              select
              fullWidth
              margin='dense'
              value={this.state.complexity}
              onChange={(e) => {
                this.handleUserStoriesComplexity(e);
              }}
            >
              {complexity.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {typeForm}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputLabel classes={{ root: classes.inputLabelsRoot }}>
              Attachments
            </InputLabel>
            <Grid
              container
              direction='row'
              justify='flex-start'
              alignItems='center'
              spacing={2}
            >
              {this.state.uploadedFilesList.map((uploadedFile) => (
                <Grid item xs={12} sm={6} md={3} lg={3}>
                  <FileAttachmentPlane
                    classes={classes}
                    onDeleteAttachment={this.onDeleteAttachment}
                    {...uploadedFile}
                  />
                </Grid>
              ))}
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <FileAttachmentButton
                  classes={classes}
                  onFilesAttach={this.onFilesAttach}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputLabel classes={{ root: classes.inputLabelsRoot }}>
              Story Success Criteria
            </InputLabel>
            <Table
              striped={true}
              tableHead={tableHeadData}
              tableData={criteriaData}
            />
            <TextField
              id='set-new-password-field'
              placeholder='Enter a new success criteria and hit add criteria.'
              fullWidth
              margin='normal'
              type={'text'}
              // helperText={
              //   errors['newPassword'] && errors['newPassword'] !== ''
              //     ? errors['newPassword']
              //     : ''
              // }
              // error={
              //   errors['newPassword'] && errors['newPassword'] !== ''
              // }
              value={this.state.storyAcceptanceText}
              name='storyAcceptanceText'
              onChange={(e) => {
                this.handleStoryAcceptanceCriteria(e);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    {' '}
                    {criteriaDataIndex}.{' '}
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='end' style={{marginBottom: 10}}>
                    <Button
                      variant='outlined'
                      size='small'
                      type='button'
                      onClick={() =>
                        this.addStoryAcceptance(this.state.storyAcceptanceText)
                      }
                    >
                      Add Criteria
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          xs={12}
          sm={12}
          md={12}
          lg={12}
          justify='space-between'
          classes={{ root: classes.lowerButtonContainerRoot }}
        >
          <Button onClick={this.back}>Back</Button>
          <Button
            variant='contained'
            color='primary'
            type='button'
            onClick={() => this.saveUserStory()}
            disabled={this.state.disabled}
          >
            {submitButtonText}
          </Button>
        </Grid>
      </>
    );
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value }, () => {
      if (this.state.storyType === 'Design Card') {
        this.handleDesignValidation();
      }
      if (this.state.storyType === 'API Card') {
        this.handleApiValidation();
      }
      if (this.state.storyType === 'Frontend Card') {
        this.handleFrontEndValidation();
      }
      if (this.state.storyType === 'Backend Card') {
        this.handleBackEndValidation();
      }
    });
  };
  /* TODO: This validation needs to be refactored.
   *   Current validations are clumsy*/
  handleDesignValidation = () => {};

  /* TODO: This validation needs to be refactored.
   *   Current validations are clumsy*/
  handleApiValidation = () => {};

  /* TODO: This validation needs to be refactored.
   *   Current validations are clumsy*/
  handleFrontEndValidation = () => {};

  /* TODO: This validation needs to be refactored.
   *   Current validations are clumsy*/
  handleBackEndValidation = () => {};

  handleApiAuthenticatedValidation = (event) => {
    if (!event.target.value.trim()) {
      this.setState({ apiAuthenticatedFieldError: true });
    } else {
      this.setState({ apiAuthenticatedFieldError: false });
    }
  };

  handleUserStoriesTitleValidation = (event) => {
    if (!event.target.value) {
      this.setState({ titleError: true });
    } else {
      this.setState({ titleError: false });
    }
  };

  handleUserStoryType = (event) => {
    const prevState = this.state.storyType;
    let descriptionContentState = null;
    let descriptionEditorState = EditorState.createEmpty();
    if (this.state.description) {
      descriptionContentState = stateFromHTML(this.state.description);
      descriptionEditorState = EditorState.createWithContent(
        descriptionContentState
      );
    }

    this.setState({ storyType: event.target.value }, () => {
      if (this.state.storyType === 'API Card' && prevState !== 'API Card') {
        this.setState({
          apiEditorDescState: descriptionEditorState,
          apiTestRefEditorDescState: EditorState.createEmpty(),
        });
      }
      if (
        this.state.storyType === 'Frontend Card' &&
        prevState !== 'Frontend Card'
      ) {
        this.setState({
          frontEndEditorDescState: descriptionEditorState,
          frontEndEditorWorkFlowState: EditorState.createEmpty(),
        });
      }
      if (
        this.state.storyType === 'Backend Card' &&
        prevState !== 'Backend Card'
      ) {
        this.setState({
          backEndEditorDescState: descriptionEditorState,
          backEndEditorWorkFlowState: EditorState.createEmpty(),
        });
      }
      if (
        this.state.storyType === 'Design Card' &&
        prevState !== 'Design Card'
      ) {
        this.setState({
          designEditorDescState: descriptionEditorState,
          designEditorElementState: EditorState.createEmpty(),
          designEditorActionElementState: EditorState.createEmpty(),
        });
      }
    });
  };

  handleUserStoriesComplexity = (event) => {
    this.setState({ complexity: event.target.value });
  };

  handleStoryAcceptanceCriteria = (event) => {
    this.setState({ storyAcceptanceText: event.target.value });
  };

  addStoryAcceptance = (criteriaText) => {
    let criteriaData = this.state.criteriaData;
    let criteriaTextList = [];
    if (criteriaData && _.isArray(criteriaData)) {
      criteriaTextList = criteriaData.map((criteria) => ({
        text: criteria[1],
      }));
      criteriaTextList.push({ text: criteriaText });
    }
    if (!criteriaData) {
      criteriaTextList.push({ text: criteriaText });
    }
    criteriaData = this.constructCriteriaTable(criteriaTextList);
    this.setState({
      criteriaData,
      storyAcceptanceText: '',
      criteriaLength: this.state.criteriaLength + 1,
    });
  };

  handleDeleteStoryAcceptance = (val) => {
    confirmAlert({
      title: 'Are you sure ?',
      message: 'Are you sure want to delete this success criteria?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            let criteriaTextList = this.state.criteriaData.map((criteria) => ({
              text: criteria[1],
            }));
            criteriaTextList.splice(val, 1);
            const criteriaData = this.constructCriteriaTable(criteriaTextList);
            this.setState({
              criteriaData,
              storyAcceptanceText: '',
              criteriaLength: this.state.criteriaLength - 1,
            });
          },
          className: 'remove-success-criteria',
        },
        {
          label: 'No',
          onClick: () => {},
        },
      ],
    });
  };

  clearForm() {
    this.setState({
      title: '',
      userStoriesDescription: '',
      complexity: 'Low',
    });
    this.props.clearSuccessCriteria();
  }

  saveUserStory = async () => {
    this.setState({ isLoading: true });
    const { editStory, projectId, sprintId, storyId } = this.state;
    if (!this.state.title) {
      this.setState({ titleError: true });
    } else {
      this.setState({ titleError: false });
    }

    if (!this.state.userStoriesDescription) {
      this.setState({ userStoriesDescriptionError: true });
    } else {
      this.setState({ userStoriesDescriptionError: false });
    }
    if (this.state.title && !this.state.userStoriesDescriptionError) {
      const titleObject = {
        role: this.state.userStoriesTitleOne,
        want: this.state.userStoriesTitleTwo,
        purpose: this.state.userStoriesTitleThree,
      };
      let descriptionObject;
      if (this.state.storyType === 'API Card') {
        descriptionObject = {
          description: this.state.userStoriesDescription,
          apiAuthenticatedField: this.state.apiAuthenticatedField,
          apiAccessibleField: this.state.apiAccessibleField,
          apiDescription: this.state.description,
          apiArchitecture: this.state.apiArchitecture,
          apiDatastore: this.state.apiDatastore,
          apiTestDesc: this.state.apiTestDesc,
          apiRefDesc: this.state.apiRefDesc,
          apiTool: this.state.apiTool,
        };
      }

      if (this.state.storyType === 'Backend Card') {
        descriptionObject = {
          description: this.state.userStoriesDescription,
          backEndTool: this.state.backEndTool,
          backEndDesignMock: this.state.backEndDesignMock,
          backEndAuthenticatedField: this.state.backEndAuthenticatedField,
          backEndAccessibleField: this.state.backEndAccessibleField,
          backEndViewNameField: this.state.backEndViewNameField,
          backEndViewNavigationField: this.state.backEndViewNavigationField,
          backEndDesc: this.state.description,
          backEndWorkFlow: this.state.backEndWorkFlow,
        };
      }

      if (this.state.storyType === 'Design Card') {
        descriptionObject = {
          description: this.state.userStoriesDescription,
          designTool: this.state.designTool,
          designMock: this.state.designMock,
          designViewNameField: this.state.designViewNameField,
          designViewNavigationField: this.state.designViewNavigationField,
          designControlField: this.state.designControlField,
          designDesc: this.state.description,
          designElement: this.state.designElement,
          designActionElement: this.state.designActionElement,
        };
      }

      if (this.state.storyType === 'Frontend Card') {
        descriptionObject = {
          description: this.state.userStoriesDescription,
          frontEndTool: this.state.frontEndTool,
          frontEndMockRef: this.state.frontEndMockRef,
          frontEndDesignMockRef: this.state.frontEndDesignMockRef,
          frontEndViewNameField: this.state.frontEndViewNameField,
          frontEndViewNavigationField: this.state.frontEndViewNavigationField,
          frontEndSwaggerField: this.state.frontEndSwaggerField,
          frontEndDesc: this.state.description,
          frontEndWorkFlow: this.state.frontEndWorkFlow,
        };
      }
      const attachments = this.state.uploadedFilesList
        .filter(
          (uploadedFile) =>
            uploadedFile.status === SUCCESS_FILE_UPLOADED ||
            uploadedFile.status === SUCCESS_FILE_UPLOADED_BEFORE
        )
        .map((uploadedFilteredFile) => ({
          id: uploadedFilteredFile.id,
          filename: uploadedFilteredFile.file.name,
          bucketLink: uploadedFilteredFile.url,
        }));

      const data = {
        title: this.state.title,
        description: descriptionObject,
        complexity: this.state.complexity,
        criteria: this.state.criteriaData.map((criteria) => criteria[1]),
        storyType: this.state.storyType,
        attachments,
      };
      if (editStory === 'editStory') {
        const updatedStory = await this.props.updateUserStories(
          data,
          projectId,
          sprintId,
          storyId
        );
        const response = await this.props.getUserStories(projectId, sprintId);
        if (response && response.data) {
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
        }
        this.setState({
          redirect: true,
        });
      } else {
        if (
          this.props.projectSavedData._id ||
          (this.props.sprintSavedData.project &&
            this.props.sprintSavedData._id) ||
          (projectId && sprintId)
        ) {
          const savedStory = await this.props.createNewUserStory(
            data,
            projectId ||
            this.props.sprintSavedData.project ||
            this.props.projectSavedData._id,
            sprintId || this.props.sprintSavedData._id
          );
          const response = await this.props.getUserStories(
            projectId ||
            this.props.sprintSavedData.project ||
            this.props.projectSavedData._id,
            sprintId || this.props.sprintSavedData._id
          );
          if (response.success) {
            this.clearForm();
            this.setState({ isLoading: false });
          } else {
            this.setState({ isLoading: false });
          }
        }
        this.setState({
          redirect: true,
        });
      }
    }
  };
}

const mapStateToProps = (state) => ({
  projectSavedData: state.project.projectSavedData,
  sprintSavedData: state.sprint.sprintSavedData,
  userStoriesSavedData: state.userStories.userStoriesSavedData,
  sprintData: state.sprint.data,
  userStoriesData: state.userStories.data,
});

const mapDispatchToProps = (dispatch) => ({
  createNewUserStory: (data, projectId, sprintId) =>
    dispatch(saveUserStories(data, projectId, sprintId)),
  clearSuccessCriteria: () => dispatch(clearSuccessCriteria()),
  getUserStories: (projectId, sprintId) =>
    dispatch(getUserStories(projectId, sprintId)),
  getOneUserStories: (projectId, sprintId, storyId) =>
    dispatch(getOneUserStories(projectId, sprintId, storyId)),
  updateUserStories: (data, projectId, sprintId, storyId, callback) =>
    dispatch(updateUserStories(data, projectId, sprintId, storyId, callback)),
});

export default withStyles(styles)(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps,
      null
    )(NewUserStory)
  )
);